// District store link resolution, shared by the two nav surfaces that render the
// Market entry (Shared/Navigation/NavigateComponent.jsx and Shared/SidebarMenu).
//
// From the 7-27 dev meeting — Becki: "where it's dynamic to where they don't even
// have to click. The thing is just smart enough to know if it's a district and they
// have something, it opens to the district right top. And then here where you've got
// our stores, there we just have all of our other stores that they can click in to
// see the FIG store or whatever else."
//
// So Market stays a single one-click item. When the district has a provisioned store
// it opens there; otherwise it opens the main FIG marketplace, unchanged. FIG's store
// and the partner stores stay reachable from the marketplace's own store directory.
//
// The slug is cached at login by applyDistrictPreferences (Pages/Login/Login.jsx) off
// the district's FigStoreSlug column. It is only set once FIG has actually provisioned
// the store, so we never deep-link a store that doesn't exist yet. A district that has
// opted in but isn't provisioned keeps the plain marketplace link rather than a 404.

export const MARKET_BASE = "https://market.figk-12.com";

/** True for the marketplace nav entry, whether or not it carries a trailing slash. */
export const isMarketUrl = (url) =>
  typeof url === "string" && url.replace(/\/+$/, "") === MARKET_BASE;

/** The district's provisioned store slug, or "" when there isn't one. */
export const getDistrictStoreSlug = () => {
  try {
    return (localStorage.getItem("district_store_slug") || "").trim();
  } catch (_) {
    // Private-mode / storage-disabled browsers — fall back to the FIG marketplace.
    return "";
  }
};

/**
 * Where the Market entry should point for this user. Falls back to the given
 * marketplace URL when the district has no store.
 */
export const resolveMarketUrl = (menuUrl) => {
  if (!isMarketUrl(menuUrl)) return menuUrl;
  const slug = getDistrictStoreSlug();
  return slug ? `${MARKET_BASE}/store/${encodeURIComponent(slug)}` : menuUrl;
};
